<template>
    <div class="skeleton">
        <div class="skeleton-inner">
            <SkeletonLoading class="skeleton-asset" />
            <div class="skeleton-content">
                <SkeletonLoading class="skeleton-title" />
                <SkeletonLoading class="skeleton-description" />
            </div>
        </div>
        <div class="skeleton-footer">
            <SkeletonLoading class="skeleton-buttons" />
        </div>
    </div>
</template>

<script lang="ts">
    // TODO: Add a Skeleton storybook component
    import SkeletonLoading from '@/components/shared/SkeletonLoading.vue';

    export default {
        name: 'Loading',
        components: { SkeletonLoading },
    };
</script>

<style lang="scss" scoped>
    @forward './Loading.scss';
</style>
